import { createSelector } from '@reduxjs/toolkit';
import { moduleNamespace } from '@Store/config.store';
import {
	Category,
	Component,
	ComponentMetadata,
	ComponentType,
	MultiParamCell,
	NamespacedStoreState,
} from '@Types';
import { useSelector } from 'react-redux';

const parseNamespace = (state: NamespacedStoreState) => state[moduleNamespace];

export const LoFStoreSelector = createSelector(
	parseNamespace,
	state => state.LoFConfig,
);

const LoFConfigSelector = createSelector(
	LoFStoreSelector,
	lofStore => lofStore.categories,
);

export const LoFConfigChanged = createSelector(
	LoFStoreSelector,
	lofStore => lofStore.isChanged,
);

export const LoFComponentInspectionFieldsSelector = createSelector(
	LoFStoreSelector,
	lofStore => lofStore.componentInspectionFields,
);

export const LoFComponentFieldsSelector = createSelector(
	LoFStoreSelector,
	lofStore => lofStore.componentFields,
);

export const selectLofStore = () => useSelector(LoFStoreSelector);

export const selectLofConfig = () => useSelector(LoFConfigSelector);

export const selectorLoFConfigChanged = () => useSelector(LoFConfigChanged);

export const selectLoFComponentInspectionFields = () =>
	useSelector(LoFComponentInspectionFieldsSelector);

export const selectLoFComponentFields = () =>
	useSelector(LoFComponentFieldsSelector);

export const selectorMaxLoFValue = createSelector(
	LoFStoreSelector,
	lofStore => {
		let maxValue = 10;

		lofStore.categories.forEach((category: Category) => {
			category.components.forEach((component: Component) => {
				if (component.select) {
					if (
						component.type === ComponentType.MultiParam &&
						component.scoreMatrix
					) {
						component.scoreMatrix.forEach(
							(data: MultiParamCell) => {
								if (data.score > maxValue)
									maxValue = data.score;
							},
						);
					} else if (component.metadata) {
						component.metadata.forEach(
							(data: ComponentMetadata) => {
								if (data.value > maxValue)
									maxValue = data.value;
							},
						);
					}
				}
			});
		});

		return maxValue;
	},
);

export const selectMaxLoFValue = (): number => useSelector(selectorMaxLoFValue);
